import React, {useEffect} from "react";
import ReactModal from "react-modal";
import { FormProvider, useForm } from "react-hook-form";
import { Input, Radio, } from "@components/form";
import { Draggable} from "@components";
import { post } from "@utils/axios_api";
function LectureCfrmModal({isOpen, onClose, onSuccess, selectedItems, lectureId}) {

  const position = Draggable({ isOpen, dragHandle: ".modal-header" });

  const methods = useForm({
    defaultValues: { eduDtCd: 'A', completeTime: 0, completeYn: 'Y' },
  });

  useEffect(() => {
    if (isOpen) {
      methods.reset({ eduDtCd: "A", completeTime: 0, completeYn: "Y" });
    }
  }, [isOpen, methods]);

  const onError = (err) => {
    alert("필수 입력란을 확인하세요.");
  }

  const onSubmit = async (values) => {
    try {
      const response = await post('/admin/lectureStudent/updateComplete', {
        memberIdList: selectedItems,
        lectureId,
        ...values,
      });
      onSuccess(response); 
      onClose();
    } catch (e) {
      alert('저장 실패');
    }
};

  const containerStyle = {
    maxWidth: "700px",
    minWidth: "700px",
    maxHeight: "300px",
    minHeight: "300px",
    transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px)`
  };

  return (
    <>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={onClose}
        overlayClassName="modal-overlay"
        className="modal-wrap"
      >
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
            <div className="modal-container" style={containerStyle}>
              <div className="modal-header" style={{ cursor: "move" }}>
                <h5>
                  수강생 수료 정보 <span className="modal-header-span">수정</span>
                </h5>
                <button type="button" className="modal-btn-close" onClick={onClose}>
                  <span className="modal-btn-span">X</span>
                </button>
              </div>
              <div className="modal-content">
                
                  <table className="table-write" style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <th>
                          수강기간 <span className="red">*</span>
                        </th>
                        <td>
                        <div style={{display:"flex", gap:"15px"}}>
                          <Radio name="eduDtCd" label="이틀" value="A" />
                          <Radio name="eduDtCd" label="첫날" value="F" />
                          <Radio name="eduDtCd" label="둘째날" value="S" />

                        </div>
                        </td>
                      </tr>
                      <tr>
                        <th>수료시간 <span className="red">*</span></th>
                        <td>
                          <Input
                            type="number"
                            name="completeTime"
                            showError={false}
                            rules={{ required:true, valueAsNumber: true }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>수료여부</th>
                        <td >
                        <div style={{display:"flex", gap:"15px"}}>
                          <Radio name="completeYn" label="수료" value="Y" />
                          <Radio name="completeYn" label="미수료" value="N" />
                        </div>  
                        </td>
                      </tr>
                    </tbody>
                  </table>
                
              </div>
              <div className="modal-btn-wrap btn-right-box">
                <ul>
                  <li><button type="button" className="btn-cancel" onClick={onClose}>취소</button></li>
                  <li><button type="submit" className="btn-save">저장</button></li>
                </ul>
              </div>
            </div>
          </form>
        </FormProvider>
      </ReactModal>
    </>
  );
}

export { LectureCfrmModal };
